import React from 'react';
import { useLocation } from 'react-router-dom';


// Define route names & types for corresponding paths
const routeProps = {
  '/': {
    name: 'homepage',
    type: 'landing'
  },
  '/grade/:grade': {
    name: 'grade',
    type: 'landing'
  },
  '/pre-k-and-k-playground': {
    name: 'playground',
    type: 'landing'
  },
  '/test-sub1stgrade-tag': {
    name: 'playground',
    type: 'landing'
  },
  '/games': {
    name: 'games',
    type: 'landing'
  },
  '/games/tinybop-schools-demo': {
    name: 'games',
    type: 'content'
  },
  '/games/:gameID': {
    name: 'games',
    type: 'content'
  },
  '/videos': {
    name: 'videos',
    type: 'landing'
  },
  '/videos/:seriesID': {
    name: 'videos',
    type: 'content'
  },
  '/:videoID': {
    name: 'videos',
    type: 'content'
  },
  '/math-zone': {
    name: 'math',
    type: 'landing'
  },
  '/books': {
    name: 'books',
    type: 'landing'
  },
  '/books/:bookID/page/:pageID': {
    name: 'books',
    type: 'content'
  },
  '/harry-moon': {
    name: 'books',
    type: 'content'
  },
  '/monster-me': {
    name: 'books',
    type: 'content'
  },
  '/teachers-and-parents': {
    name: 'teachers',
    type: 'landing'
  },
  '/advertise-with-funbrain': {
    name: 'advertise-with-us',
    type: 'landing'
  },
  '/about': {
    name: 'about',
    type: 'about'
  },
  '/privacy-policy': {
    name: 'privacy',
    type: 'about'
  },
  '/search': {
    name: 'search',
  },
  '/terms-of-use': {
    name: 'terms',
    type: 'about'
  },
  '/error/page-not-found': {
    name: 'pageNotFound',
    type: 'about',
    errorCode: '404'
  },
  '/error/forbidden': {
    name: 'forbidden',
    type: 'about',
    errorCode: '403'
  },
  '*': {
    name: 'pageNotFound',
    type: 'about',
    errorCode: '404'
  },
}



export const useRouteProps = () => {
  const location = useLocation();

  for (const [key, value] of Object.entries(routeProps)) {
    if (location.pathname.length === 1 && location.pathname.startsWith('/') && key === '/') {
      return value;
    } else if (key !== '/' && location.pathname.indexOf(key) === 0) {
      return value;
    }
  }

  return null;
}